<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="" title="Products" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<router-link :to="{ name: 'add_product' }" class="btn btn-primary float-end">Add Product</router-link>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select" v-model="listing_length" @change="products()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="products()">
											<option value="">All</option>
                                            <option value="1">Active</option>
                                            <option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="products()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Product Name</th>
											<th>Image</th>
											<th>Stock</th> 
											<th>Status</th> 
											<th>Action</th> 
                                        </tr>
									</thead>
									<tbody v-if="Boolean(productList.length)">
										<tr align="center" v-for="(product, index) in productList" :key="product.id">
                                            <td>{{ (from - 1) + index+1 }}</td>
                                            <td>
												{{ product.product_name }}
											</td>
											<td>
												<img v-if="product.image" :src="imageUrl + product.image" class="product-image mt-2" alt="Product Image" />
											</td>
											<td>{{ product.current_stock }}</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="product.status === 1">Active</span>
												<span class="badge rounded-pill bg-warning" v-else>Blocked</span>
											</td>
                                            <td>
												<router-link :to="{ name: 'edit_product', query: {id: product.id } }" class="btn btn-primary btn-sm me-2 mb-2">Edit</router-link>
												<button class="btn btn-info btn-sm me-2 mb-2" @click="updateStockModalShow(product.id)">Update Stock</button><br>                
                                                <button class="btn btn-warning btn-sm me-2 mb-2" v-if="product.status === 1" @click="updateStatus(product.id, 2)">Block</button>
                                                <button class="btn btn-success btn-sm me-2 mb-2" v-if="product.status === 2" @click="updateStatus(product.id, 1)">Activate</button>												
												<router-link :to="{ name: 'product_stock_logs', query: {id: product.id} }" class="btn btn-primary btn-sm me-2 mb-2">Stock Logs</router-link><br>
												<router-link :to="{ name: 'speed_governors' }" class="btn btn-secondary btn-sm me-2 mb-2" v-if="product.id === 3">Show All</router-link>
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No products found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<div class="row mt-2">
								<div class="col-md-6">
									<p class="text-muted mb-0">
										Showing {{ from || 0 }} to {{ to || 0 }} of {{ total || 0 }} entries
									</p>
								</div>
								<div class="col-md-6">
									<nav aria-label="Page navigation">
										<ul class="pagination justify-content-end">
											<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
												<a class="page-link" href="#" @click.prevent="products(page.url)" tabindex="-1">
													<span v-if="index === 0">Prev</span>
													<span v-else-if="index === pagination.length - 1">Next</span>
													<span v-else v-html="page.label"></span>
												</a>
											</li>
										</ul>
									</nav>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Type<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="type">
								<option value="">--Select--</option>
								<option value="1">Add Stock</option>
								<option value="2">Remove Stock</option>
							</select>
							<span class="validate-error" v-if="errors.type">
								{{ errors.type[0] }}
							</span>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Stock<span class="text-danger">*</span></label>
                        	<input v-model="stock" class="form-control" rows="3"/>
							<span class="validate-error" v-if="errors.stock">
								{{ errors.stock[0] }}
							</span>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" @click="updateStock()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="hideModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

	</div>
</template>

<script setup>
import { ref, reactive, onMounted,inject } from 'vue';
import { Modal } from 'bootstrap';
import DynamicModal from '@/components/dynamic_modal.vue';
import { get, post } from '@/utils/api.js';
import { routes } from '@/constants/routes.js';
import Swal from '@/utils/swal';
import { useRouter } from 'vue-router';

const router = useRouter();

let modalInstance = null;

const imageUrl = inject('imageUrl');
const modal_title = ref('Update Stock');
const button_title = ref('Update');

const keyword = ref('');
const showsearch = ref(false);
const listing_length = ref(10);
const token = ref('');
const errors = ref({});
const status = ref('');
const stock = ref('');
const productList = ref([]);
const type = ref('');
const selectedProductId = ref('');
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const showModal = () => {
  if (modalInstance) modalInstance.show();
};

const hideModal = () => {
  if (modalInstance) modalInstance.hide();
};

const updateStockModalShow = (product_id) => {
  errors.value = {};
  selectedProductId.value = product_id;
  type.value = '';
  stock.value = '';
  modal_title.value = 'Update Stock';
  button_title.value = 'Update';
  showModal();
};

const clearForm = () => {
  type.value = '';
  stock.value = '';
  modal_title.value = 'Update Stock';
  button_title.value = 'Update';
};

onMounted(() => {
  modalInstance = new Modal(document.getElementById('dynamicmodal'));
  products();
});

const products = (url = null) => {

  const params = {
    limit: listing_length.value,
    keyword: keyword.value,
    status: status.value
  };

  const requestUrl = url ?? routes.Products;

  get(requestUrl, { params }, false)
    .then((response) => {
      if (response.status === 200) {
		console.log(response.data.data);
        productList.value = response.data.data.data;
		pagination.value = response.data.data.links;
		from.value = response.data.data.from;
		to.value = response.data.data.to;
		total.value = response.data.data.total;
      } else {
        Swal.fire('', response.data.message || 'Error fetching data', 'error');
      }
    })
    .catch((error) => {
      if (error.response?.status === 422) {
        Swal.fire('', error.response.data.message || 'Validation error', 'error');
      } else if (error.response?.status === 500) {
        Swal.fire('', error.response.statusText || 'Server error', 'error');
      } else if (error.response?.status === 401) {
        Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
        router.push({ name: 'login' });
      } else {
		Swal.fire('', error.response.data?.message || 'Error occured', 'error');
	  }
    });
};

const updateStatus = (product_id, status) => {

	const params = {
		'product_id': product_id,
		'status': status
	};

	get(routes.ProductStatusUpdate, { params }, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Product status updated successfully', 'success');
				products();
			} else {
				Swal.fire('', response.data.message || 'Error in updating status', 'error');
			}
		})
		.catch((error) => {
			if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const updateStock = () => {

	const formData = new FormData();
	formData.append('product_id', selectedProductId.value);
	formData.append('type', type.value);
	formData.append('stock', stock.value);

	post(routes.UpdateProductStock, formData, false)
		.then((response) => {
			if(response.status === 200){
				Swal.fire('', response.data.message || 'Product stock updated successfully', 'success');
				hideModal();
				clearForm();
				products();
			} else {
				Swal.fire('', response.data.message || 'Failed to update product stock', 'error');
			}
		})
		.catch((error) => {
			if(error.response.status == 422){
    			errors.value = error.response.data.message;
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});

};

</script>

